import SiteAdminHome from "../sites/pages/SiteAdminHome";

export const AdminRoutes: Array<string> = [
    "/content",
    "/subscribers",
    "/users",
    "/account",
    "/admin",
    "/systemadmin",
    "/details"
]